import './pwaInstall';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './auth/msalInstance';
import { registerServiceWorker } from './registerSW';

// MSAL v3 requires initialize() to be called and awaited before
// any other MSAL API is used. Without this, handleRedirectPromise
// throws uninitialized_public_client_application and causes a login loop.
msalInstance.initialize().then(() => {
  msalInstance.handleRedirectPromise().catch((e) => console.error('Redirect error:', e));

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>
  );
  registerServiceWorker();
});
